export const calculateResponseRate = (submissions: number, expected: number | null): number | null => {
  if (expected === null || expected === 0) return null;
  return Math.min(Math.round((submissions / expected) * 100), 100);
};

export const getResponseRateColor = (rate: number | null): string => {
  if (rate === null || rate === 0) return '#ee7f5c';
  if (rate < 25) return '#efa3a5';
  if (rate < 75) return '#f9d9bb';
  return '#53c55f';
};
